import AceEditor from 'react-ace';
import 'ace-builds/webpack-resolver';
import { useTheme } from '@mui/material/styles';
import React, { RefObject } from 'react';
export default function JsonField({
    ref,
    value,
    onChange,
    height,
    readOnly = false,
}: {
    ref?: RefObject<AceEditor>;
    value: string;
    onChange?: (newValue: string) => void;
    height?: string;
    readOnly?: boolean;
}) {
    const appTheme = useTheme();

    return (
        <AceEditor
            readOnly={readOnly}
            height={height ?? '120px'}
            ref={ref}
            mode={'json'}
            theme="cloud9_day"
            onChange={onChange}
            fontSize={appTheme.typography.fontSize}
            showPrintMargin={false}
            showGutter
            highlightActiveLine
            value={value}
            width="100%"
            setOptions={{
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                showLineNumbers: true,
                tabSize: 2,
                fontFamily: appTheme.font.monospace,
            }}
        />
    );
}
